import { DISMISS_MESSAGES } from "./action_types"

export const dismissMessages = () => ({ type: DISMISS_MESSAGES })
